export default {
    data() {
        return {
            expanded: false,
            alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            filteredconditions: [],
        };
    },
    computed: {
        alphabetLetters() {
            return this.alphabet.split('').filter(letter =>
                this.conditions.some(condition =>
                    condition.name.trim().toUpperCase().startsWith(letter)
                )
            );
        },
        showBackButton() {
            return this.filteredconditions.length > 0;
        },
        showconditions() {
            return this.filteredconditions.length > 0;
        },
    },
    methods: {
        showTitle() {
            return this.name
        },
        toggleExpanded() {
            this.expanded = !this.expanded;
            if (this.expanded) {
                document.addEventListener('click', this.handleClickOutside);
            } else {
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        filterconditions(letter) {
            this.filteredconditions = this.conditions.filter(condition => {
                const cleanedName = condition.name;
                return cleanedName.charAt(0).toUpperCase() === letter;
            });
        },
        goBack() {
            this.filteredconditions = [];
            this.expanded = true;
        },
        collapseBanner() {
            this.expanded = false;
            document.removeEventListener('click', this.handleClickOutside);
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.collapseBanner();
                this.filteredconditions = [];
            }
        },
    },
    props: {
        conditions: {
            type: Array,
            default: () => [],
        },
        name: {
            type: String
        }
    },
};